import { Cliente } from '../domain/cliente.model';
import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';

export class ClienteSerializer extends DomainSerializer<Cliente> {}
